/**
 * Update date: 2025-05-15
 * Screen 2044.D
 */
import LoadPanel from 'app/components/LoadPanel';
import { NotFoundPage } from 'app/components/NotFoundPage';
import useDictionary from 'hooks/useDictionary';
import useLocalStorage from 'hooks/useLocalStorage';
import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';

const List = React.lazy(() => import('./List'));
const DeleteZoneMove = React.lazy(() => import('./DeleteZoneMove'));

/**
 * create context
 */
const ModuleContext = createContext({});
ModuleContext.displayName = 'M2044_D_Context';
export const useModuleContext = () => {
  return useContext(ModuleContext);
};

const M2044_D = () => {
  const [dataListLocal, setDataListLocal] = useLocalStorage(
    '2044.D_dataList',
    {},
  );
  const { t }: any = useDictionary({ programId: '2044.D' });
  const stockMinRef: any = useRef(null);
  const [data, setData] = useState([]);
  const [modeView, setModeView] = useState<any>({
    type: 'list',
  });
  const [formSearchData, setFormSearchData] = useState<any>({
    fromDate: new Date(),
    endDate: new Date(),
    fromTime: new Date(),
    endTime: new Date(),
    fromDeliveryDate: null,
    endDeliveryDate: null,
    fromIsCheck: false,
    endIsCheck: false,
    addressFilterType: '0',
    dataList: {
      mall: [],
      fromZone: [],
      toZone: [],
      toLocation: [],
      storeGroup: [],
      store: [],
      receivableCd: [],
      addressFilter: [],
      productType: [],
      productGroup: [],
    },
    mall: '',
    fromZone: '',
    toZone: '',
    toLocation: '',
    storeGroup: '',
    store: '',
    receivableCd: '',
    addressFilter: '',
    productType: '',
    productGroup: '',
    searchKeyWordIn: '1',
    keyWord: '',
    priOrDel: '',
  });

  /**
   * fetch data
   */
  useEffect(() => {
    setFormSearchData(preState => ({
      ...preState,
      dataList: {
        ...preState?.dataList,
        mall: dataListLocal?.mall || [],
        receivableCd: dataListLocal?.receivableCd || [],
        fromZone: dataListLocal?.fromZone || [],
        toZone: dataListLocal?.toZone || [],
        toLocation: dataListLocal?.toLocation || [],
        productType: dataListLocal?.productType || [],
      },
    }));
  }, [dataListLocal]);

  const value: any = {
    t,
    data,
    setData,
    modeView,
    setModeView,
    formSearchData,
    setFormSearchData,
    setDataListLocal,
    stockMinRef,
  };

  /**
   * render content
   *
   * @return {*}
   */
  const renderContent = () => {
    switch (modeView?.type) {
      case 'list':
        return <List />;
      case 'delete':
        return <DeleteZoneMove />;
      default:
        return <NotFoundPage />;
    }
  };

  return (
    <ModuleContext.Provider value={value}>
      <React.Suspense fallback={<LoadPanel visible={true} />}>
        {renderContent()}
      </React.Suspense>
    </ModuleContext.Provider>
  );
};

export default M2044_D;
